<home-ui [steps]="steps"></home-ui>
